import { useRouter } from 'next/router';
import React from 'react';
import URI from 'urijs';
import { useResponsive } from 'Components/utils/responsive/ResponsiveContext';
import { HASH_PARAMS_DELIMITER } from 'Utils/uri/constants';
import { useTracking } from 'Tracking/tracking-api/useTracking';
import type { IconName } from 'Components/frameworks/icon/Icon';
import { Line } from 'Components/frameworks/line/Line';
import { CollapsePanel } from 'Components/frameworks/collapse-panel/CollapsePanel';
import { SiteContainer } from 'Components/frameworks/site-container/SiteContainer';
import type { LineProps } from './resolver';
type CollapsePanelProps = {
  componentId: string;
  children?: React.ReactNode;
  header: string;
  icon: IconName;
  collapseLabel?: string;
  expandLabel?: string;
  displayed: boolean;
};

const Panel = ({
  displayed,
  children = <div />,
  componentId,
  header,
  icon,
  collapseLabel = '',
  expandLabel = '',
}: CollapsePanelProps) => {
  const track = useTracking();
  const { asPath } = useRouter();
  const hash = new URI(asPath).hash();
  const { isAppMounted } = useResponsive();
  const cleanedHash = hash && isAppMounted ? hash.split(HASH_PARAMS_DELIMITER)[0] : null;
  const defaultExpanded = cleanedHash ? cleanedHash === `#${componentId}` : false;

  if (!displayed) {
    return null;
  }

  return (
    <div className="Line Line-ProductInformation">
      <SiteContainer className="px-0">
        <CollapsePanel
          as="h2"
          collapseLabel={collapseLabel}
          expandLabel={expandLabel}
          headerClassName="mx-20"
          iconName={icon}
          id={componentId}
          isExpanded={defaultExpanded}
          onClick={() =>
            track({
              actionGA: 'blockInfos',
              labelGA: componentId,
            })
          }
          title={header}
        >
          <div className="px-20">{children}</div>
        </CollapsePanel>
      </SiteContainer>
    </div>
  );
};

const EditorialFoldingLine = (props: LineProps) => <Line component={Panel} props={props} />;

export default EditorialFoldingLine;
